import {
  FinanceApplication,
  FinanceResponse,
} from '@upstart/harmony/lib/legos/financingTypes';
import {
  FinanceProvider,
  FinanceResponseStatus,
} from '@upstart/harmony/lib/legos/constants';
import { isKeyOfEnum } from '@upstart/harmony/lib/legos/utils/tsutils';
import { LendingValueBadgeEnum } from '@upstart/desking-components';

export const UPSTART_DUPLICATE_OFFER_LIMIT = 5;
const COUNTER_LOWEST_MONTHLY_BADGE_VALUE = 'COUNTER_LOWEST_MONTHLY';

/**
 * Determines if the limit for duplicate Upstart offers has been reached
 * @param applications
 * @param responses
 */
export function isDuplicateUpstartOfferLimitReached(
  applications: FinanceApplication[],
  responses: FinanceResponse[],
) {
  const numUpstartFinanceResponses = responses.reduce((acc, fr) => {
    const fa = applications.find(
      application =>
        application.id === fr.applicationId &&
        application?.provider === FinanceProvider.UPSTART,
    );
    return fa ? acc + 1 : acc;
  }, 0);
  return numUpstartFinanceResponses >= UPSTART_DUPLICATE_OFFER_LIMIT;
}

export function getLendingValueBadgeEnum(
  response?: FinanceResponse,
  isInvalid?: boolean,
) {
  if (!response) {
    return null;
  }
  if (isInvalid) {
    return LendingValueBadgeEnum.NEEDS_ADJUSTMENT;
  }
  const { primaryValueBadge } = response.data ?? {};
  if (
    primaryValueBadge?.value &&
    isKeyOfEnum(LendingValueBadgeEnum, primaryValueBadge.value)
  ) {
    return LendingValueBadgeEnum[primaryValueBadge?.value];
  }
  return null;
}

export function isApprovedCounter(response: FinanceResponse) {
  return (
    response.status === FinanceResponseStatus.COUNTERED &&
    !response.validations?.isInvalid
  );
}

export function isAutoAdjustedCounterOffer(response?: FinanceResponse) {
  return (
    response?.data?.primaryValueBadge?.value ===
    COUNTER_LOWEST_MONTHLY_BADGE_VALUE
  );
}
